
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '不動産の査定は本当に無料ですか？',
      answer: 'はい、査定は完全無料です。お客様に費用をご負担いただくことは一切ございません。専門スタッフが現地調査を行い、適正な価格をご提示いたします。'
    },
    {
      question: '売却にはどのくらいの期間がかかりますか？',
      answer: '物件の条件や市場状況により異なりますが、一般的には3〜6ヶ月程度です。お急ぎの場合は買取サービスもご利用いただけ、最短1週間での現金化も可能です。'
    },
    {
      question: '仲介手数料はいくらかかりますか？',
      answer: '仲介手数料は法定上限額（売買価格×3%+6万円+消費税）以内で設定しております。詳細な金額については、査定時にご説明いたします。'
    },
    {
      question: '住宅ローンが残っていても売却できますか？',
      answer: 'はい、可能です。売却代金でローンを完済する方法や、住み替えローンのご利用など、お客様の状況に応じて最適な方法をご提案いたします。'
    },
    {
      question: '遠方に住んでいても依頼できますか？',
      answer: 'もちろん可能です。お電話やメールでのやり取りを中心に進めさせていただき、必要に応じて現地での立ち会いも調整いたします。'
    },
    {
      question: '相続した不動産の売却も対応していますか？',
      answer: 'はい、相続不動産の売却も承っております。相続登記から売却まで、提携司法書士と連携してトータルサポートいたします。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            よくある質問
          </h2>
          <p className="text-xl text-gray-600">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex justify-between items-center"
              >
                <h4 className="font-semibold text-gray-900 pr-4">{faq.question}</h4>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-blue-600 text-xl flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Structured Data for FAQ */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
}
